module.exports = __webpack_public_path__ + "img/128-spain.79b0098d.svg";